module.exports = __webpack_public_path__ + "img/elecprice.8d55d149.png";